import { TimeDistanceCalculatorType } from "./enumerators";

export const timeDistanceCalculatorTypeDisplayMap: { [key: string]: string } = {
  [TimeDistanceCalculatorType.Quest]: "Estimated Driving Distance",
  [TimeDistanceCalculatorType.GeographyAware]: "Geographic Distance",
  [TimeDistanceCalculatorType.GraphhopperRouting]: "Routing Distance [EXPERIMENTAL]",
  [TimeDistanceCalculatorType.StraightLine]: "Straight-Line Distance",
};